
type NoArgFunction = () => unknown;

/**
 * Run a function after a delay. Resets the delay if the same function is
 * queued to run before the delay expires.
 *
 * @param delay - the delay expressed in milliseconds. This is passed directly
 * to setTimeout.
 */
export const cooldown = (delay: number, key: object, fn: NoArgFunction) => {
    if(cache.has(key)) {
        const timeout = cache.get(key);
        clearTimeout(timeout);
    }
    // Silence TypeScript's assumption that this is NodeJS, not browser code
    // @ts-ignore
    const timeout: number = setTimeout(() => {
        cache.delete(key);
        fn();
    }, delay);

    cache.set(key, timeout);
}

const cache = new WeakMap<object, number>();
